import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear, addWeeks, addMonths, addYears } from '../../date-fns-local';
import { IPredefinedInterval } from '../mdc-daterange-picker/i-predefined-interval';

export function getPredefinedIntervals(firstDay: 0 | 1 | 2 | 3 | 4 | 5 | 6): IPredefinedInterval[] {
  return [
    { label: 'This week', from: startOfWeek(Date.now(), { weekStartsOn: firstDay }), to: endOfWeek(Date.now(), { weekStartsOn: firstDay }) },
    { label: 'This month', from: startOfMonth(Date.now()), to: endOfMonth(Date.now()) },
    { label: 'This year', from: startOfYear(Date.now()), to: endOfYear(Date.now()) },
    { label: 'This year to date', from: startOfYear(Date.now()), to: new Date() },
    { label: 'Last week', from: addWeeks(startOfWeek(Date.now(), { weekStartsOn: firstDay }), -1), to: addWeeks(endOfWeek(Date.now(), { weekStartsOn: firstDay }), -1) },
    { label: 'Last month', from: addMonths(startOfMonth(Date.now()), -1), to: endOfMonth(addMonths(startOfMonth(Date.now()), -1)) },
    { label: 'Last year', from: addYears(startOfYear(Date.now()), -1), to: endOfYear(addYears(startOfYear(Date.now()), -1)) },
    { label: 'Last year to date', from: addYears(startOfYear(Date.now()), -1), to: new Date() },
    { label: 'Show all', from: new Date(1950, 0, 1), to: new Date() },
  ];
}
